import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'app/store/app.states';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { CoalService } from 'app/services/coal.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { DialogNewPlaceComponent } from './dialog-new-place/dialog-new-place.component';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'settings-place',
  templateUrl: './place.component.html',
  styleUrls: ['./place.component.scss']
})
export class SettingsPlaceComponent implements OnInit, OnChanges {
  @Input() idEmpresa: number;
  @Input() Observable$: BehaviorSubject<any>;
  objetoGridConfiguration: any;
  nombreReporte: string;
  datosevent: any;
  datosEventPlace: any;
  objetosSelected: any;
  verGrid: boolean = false;
  formModo: number = 0;
  descargarExcel = true;


  constructor(
    private store: Store<AppState>,
    private coalService: CoalService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog
  ) {}
  ngOnInit(): void {
    this.ObjectGrid();
    this.getInitialData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.idEmpresa?.currentValue) {
      this.getInitialData();
    }
  }

  ObjectGrid() {
    let that = this;
    this.nombreReporte = 'Lugares';
    this.objetoGridConfiguration = {
        GridOptions: {
            paginacion: 20,
            pageSize: ['40', '60', '80', '100'],
        },
        ExportExcel: { enabled: false, fileName: 'Historico' },
        ColumnHiding: { hide: true },
        Checkbox: { checkboxmode: 'single' },
        Editing: { allowupdate: true, mode: 'cell' },
        Columnchooser: { columnchooser: true },
        SearchPanel: {
            visible: true,
            width: 200,
            placeholder: 'Buscar...',
            filterRow: true,
        },
        Scroll: { mode: 'infinite' },
        Color: null,
        Detail: { detail: true },
        ToolbarDetail: null,
        ToolBox: [
          {
            location: 'after',
            widget: 'dxButton',
            locateInMenu: 'auto',
            options: {
                width: 80,
                onClick: this.series.bind(this),
                text: 'Series'
                // icon: '../../../assets/icons/ver.png',
            },
            visible: true,
            name: 'simple',
        },
        {
            location: 'after',
            widget: 'dxButton',
            locateInMenu: 'auto',
            options: {
                width: 60,
                onClick: this.modificar.bind(this),
                icon: '../../../assets/icons/ver.png',
            },
            visible: true,
            name: 'simple',
        },
        {
            location: 'after',
            widget: 'dxButton',
            locateInMenu: 'auto',
            options: {
                width: 60,
                icon: '../../../assets/icons/borrar.png',
                onClick: this.eliminar.bind(this),
            },
            visible: true,
            name: 'simple',
        },
        ],
        Columns: [],
        Data: [],
        Columns1: [1],
        Data1: [],
        datosMessage(evento) {
            that.objetosSelected = evento.data;
        },
    };
    this.DataColumnsGrid();
  }

  DataColumnsGrid() {
    let columnsMulti = [];
      columnsMulti.push({
          caption: 'Nombre',
          dataField: 'attributes.nombre',
          allowEditing: false,
          fixed: true,
      });
      columnsMulti.push({
          caption: 'Descripción',
          dataField: 'attributes.descripcion',
          allowEditing: false,
      });
      columnsMulti.push({
          caption: 'CP',
          dataField: 'attributes.dir_direccion.data.attributes.codigoPostal',
          allowEditing: false,
      });
    this.objetoGridConfiguration.Columns = columnsMulti;
  }

  getInitialData() {
    this.store.dispatch(MostrarSpinner());
    this.coalService.getService(`ope-empresas?filters[id]=${this.idEmpresa}&populate[0]=ope_direccion_empresas.dir_direccion.dir_asentamiento.dir_codigo_postal`)
    .subscribe(
      (res: any) => {
        this.store.dispatch(OcultarSpinner());
        this.objetoGridConfiguration.Data = res.data[0]?.attributes.ope_direccion_empresas?.data;
        this.verGrid = true;
        this.formModo = 1;
      }, (error: any) => {
        this.store.dispatch(OcultarSpinner());
      }
    )
  }

  eliminar(e) {
    this.store.dispatch(MostrarSpinner());
    this.coalService.deleteService('ope-direccion-empresas/', this.datosevent.id)
    .subscribe((res:any) => {
      this.getInitialData();
      this.store.dispatch(OcultarSpinner());
      this.Observable$.next(1);
    }, (error: any) => {
      this.store.dispatch(OcultarSpinner());
    })
  }

  newPlace (data) {
    const dialogRef = this.dialog.open(DialogNewPlaceComponent, {
      width: '700px',
      data: {...data, idEmpresa: this.idEmpresa},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.success == 1) {
        this.getInitialData();
        this.Observable$.next(1);
      }
    });
  }

  modificar() {
    const dialogRef = this.dialog.open(DialogNewPlaceComponent, {
      width: '700px',
      data: this.datosevent,
      disableClose: false
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.success == 1) {
        this.getInitialData();
        
      }
    });
  }

  series() {
    this.formModo = 2;
  }

  datosMessage($event) {
    try {
        this.datosevent = $event.data[0];
    } catch (error) {
        // this.Excepciones(error, 1);
    }
  }

  cancelForm () {
    this.formModo = 1;
    this.getInitialData();
  }
}
